import React from 'react';
import { Paper, Button, CircularProgress } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import { JsonToCsvConverter, download } from '../../../Util/utilsFunctions';

// Products with ZERO scans in the window — the inverse of "most viewed", and
// often more actionable for clearing slow stock. Capped server-side at 500.
// Loaded on its own request, so `loading` is shown while the rest of the
// dashboard is already on screen.
const DeadInventory = ({ deadInventory, loading }) => {
  const rows = deadInventory?.rows || [];
  const total = deadInventory?.total || 0;

  const handleDownload = () => {
    if (!rows.length) return;
    download('Dead-Inventory', JsonToCsvConverter(rows));
  };

  return (
    <Paper className="insights__card insights__col-6" variant="outlined">
      <div className="insights__card-head">
        <div>
          <span className="insights__card-title">No-Scan Products</span>{' '}
          <span className="insights__card-sub">
            {loading ? '…' : `${total} with zero scans`}
          </span>
        </div>
        <Button
          size="small"
          onClick={handleDownload}
          endIcon={<GetAppIcon />}
          disabled={!rows.length}
        >
          CSV
        </Button>
      </div>
      {loading ? (
        <div className="insights__empty">
          <CircularProgress size={22} />
          <div style={{ marginTop: 8 }}>Finding unscanned products…</div>
        </div>
      ) : rows.length === 0 ? (
        <div className="insights__empty">Every product was scanned 🎉</div>
      ) : (
        <div className="insights__scroll" style={{ maxHeight: 300 }}>
          <table className="insights__table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Manufacturer</th>
                <th>Class</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr
                  key={r.product_uuid}
                  onClick={() =>
                    window.open(`/product/${r.product_uuid}`, '_blank')
                  }
                >
                  <td>{r.trade_name}</td>
                  <td>{r.manufacturer_name}</td>
                  <td>{r.material_class}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Paper>
  );
};

export default DeadInventory;
